import { MondayCampaignTemplateDTO } from "generated/schemas";
import TouchpointIcon from "containers/admin/clients/touchpoint/components/touchpoint-icon/touchpoint-icon";

import { getTouchpointTypeFromMondayChannel } from "utilities/monday-channel";

interface SelectedTemplatesProps {
  selectedCampaignTemplates: string[];
  campaignTemplates: MondayCampaignTemplateDTO[];
}

const SelectedTemplates = ({
  selectedCampaignTemplates: selectedCampaignTemplate,
  campaignTemplates,
}: SelectedTemplatesProps) => {
  if (!selectedCampaignTemplate?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 mb-4">
      <p className="">Selected campaign templates:</p>
      <div className="flex flex-col gap-2">
        {selectedCampaignTemplate.map((templateId: string) => {
          const template = campaignTemplates.find((t) => t.id === templateId);
          if (!template) {
            return null;
          }
          return (
            <div className="flex items-center gap-1" key={templateId}>
              <TouchpointIcon
                touchpointType={getTouchpointTypeFromMondayChannel(
                  template.campaignChannel ?? template.touchpointTemplates?.[0]?.touchpointChannel,
                )}
                className="size-4 shrink-0"
              />
              <p className=" text-sm">{template.campaignTemplate}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedTemplates;
